import axios from 'axios';
import apiUrl from '../Config';


function getCookie(name) {
  const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
  return match ? decodeURIComponent(match[1]) : "";
}
const token = getCookie("token");

export const getTestimonials = async () => {
  try {
    const response = await axios.get(`${apiUrl}/testimonials/getalltestimonial`)
    return response.data
  } catch (error) {
    console.error(error)
  }
}
export const fetchCategories = async () => {
  try {
    const response = await axios.get(`${apiUrl}/categories/getallcategories`);
    return response.data?.category || [];
  } catch (error) {
    console.error(error);
    return [];
  }
};

export const getallbooksdata = async () => {
  try {
    const response = await axios.get(`${apiUrl}/books/getallbooks`);
    return response.data.books
  } catch (error) {
    console.error("Error fetching book data:", error);
    return [];
  }
};

export const getUpcomingBooks = async () => {
  try {
    const response = await axios.get(`${apiUrl}/upcomingbooks/getallupcommingbook`);
    return response.data.upcomingbooks
  } catch (error) {
    console.error(error)
  }
}

export const addtoCart = async ({ bookId, comboId, quantity = 1 }) => {
  try {
    const payload = {};
    if (bookId) payload.bookId = bookId;
    if (comboId) payload.comboId = comboId;
    payload.quantity = quantity;

    const response = await axios.post(
      `${apiUrl}/cart/addtocart`,
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(error, "addtocart");
  }
}

export const getUserCart = async () => {
  try {
    const response = await axios.get(`${apiUrl}/cart/getcart`,
      {
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      });
    return response.data;
  } catch (error) {
    console.error(error, 'getusercart');
  }
}

export const increamentCart = async (cartItemId, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/cart/incrementcartitem/${cartItemId}`,
      JSON.stringify(data),
      {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(error, 'incrementcart');
  }
}
export const decreamentCart = async (cartItemId, data) => {
  try {
    const response = await axios.put(
      `${apiUrl}/cart/decrementcartitem/${cartItemId}`,
      JSON.stringify(data),
      {
        headers: {
          'Content-Type': 'text/plain'
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error(error, 'decrementcart');
  }
}

export const DeleteCart = async (cartItemId, data) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/cart/deletecartitem/${cartItemId}`,
      {
        headers: {
          'Content-Type': 'text/plain'
        },
        data: JSON.stringify(data)
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}
export const getallcombooffer = async () => {
  try {
    const response = await axios.get(`${apiUrl}/combooffers/getallcombooffer`);
    return response.data
  } catch (error) {
    console.error("fetchcombodata ", error)
    return [];
  }
}

// export const loginUser = async (email, password) => {
//   try {
//     const response = await axios.post(`${apiUrl}/user/login`, {
//       email,
//       password
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

// export const registerUser = async (name, email, password) => {
//   try {
//     const response = await axios.post(`${apiUrl}/user/register`, {
//       name,
//       email,
//       password
//     });
//     return response.data;
//   } catch (error) {
//     throw error;
//   }
// };

export const registerUserotp = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/user/register`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const generateOTP = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/user/sendotp`, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
}


export const sentotplogin = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/user/sentotplogin`, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const verifyotplogin = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/user/verifyloginotp`, payload);
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const sendContactEnquiry = async (payload) => {
  try {
    const response = await axios.post(
      `${apiUrl}/enquiries/createenquiry`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRelatedBooks = async (bookId, subCategoryId) => {
  try {
    const res = await axios.get(`${apiUrl}/books/relatedbooks/${bookId}/subcategory/${subCategoryId}`);
    return res.data.relatedBooks || [];
  } catch (error) {
    console.error("Error fetching related books:", error);
    return [];
  }
};

export const getAllFaqs = async () => {
  try {
    const response = await axios.get(`${apiUrl}/faqs/getallfaqs`);
    return response.data?.faqs || [];
  } catch (error) {
    console.error("Error fetching FAQs:", error);
    return [];
  }
};

export const getAllBlogs = async () => {
  try {
    const res = await axios.get(`${apiUrl}/blogs/getallblogs`);
    return res.data?.blogs || [];
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return [];
  }
};

export const getBlogById = async (id) => {
  try {
    const res = await axios.get(`${apiUrl}/blogs/getblogbyid/${id}`);
    return res.data?.blog || null;
  } catch (err) {
    console.error("Failed to fetch blog:", err);
    return null;
  }
};

export const getRelatedBlogs = async (id) => {
  try {
    const res = await axios.get(`${apiUrl}/blogs/getrelatedblogs?blogId=${id}`);
    return res.data?.data || [];
  } catch (err) {
    console.error("Failed to fetch related blogs:", err);
    return [];
  }
};

export const getAllCategories = async () => {
  try {
    const res = await axios.get(`${apiUrl}/categories/getallcategories`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data?.category || [];
  } catch (err) {
    console.error("Failed to fetch categories:", err);
    return [];
  }
};

export const createUserAddress = async (payload, token) => {
  try {

    const res = await axios.post(
      `${apiUrl}/useraddress/createuseraddress`,
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return res.data;
  } catch (error) {
    console.error(error)

  }
};

export const getuserAddress = async (token) => {
  try {
    const response = await axios.get(
      `${apiUrl}/useraddress/getuseraddress`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
}

export const updateuserAdderss = async (id, data, token) => {
  try {
    const response = await axios.put(
      `${apiUrl}/useraddress/updateuseraddress/${id}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
}

export const deleteUserAddress = async (id, token) => {
  try {
    const response = await axios.delete(
      `${apiUrl}/useraddress/deleteuseraddress/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting user address:', error);
  }
};

export const getAllDeliveryPrices = async () => {
  try {
    const res = await axios.get(`${apiUrl}/deliveryprices/getalldeliveryprices`);
    return res.data?.prices || [];
  } catch (error) {
    console.error("Error fetching delivery prices:", error);
    return [];
  }
};

export const getUserAddresses = async () => {
  try {
    const res = await axios.get(`${apiUrl}/useraddress/getuseraddress`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return res.data.addresses || [];
  } catch (error) {
    console.error("Error fetching user addresses:", error);
    return [];
  }
};

export const getUserProfile = async (apiToken) => {
  const passtoken = apiToken || token;
  try {
    const res = await axios.get(`${apiUrl}/user/myprofile`, {
      headers: { Authorization: `Bearer ${passtoken}` },
    });
    return res.data?.profileDetails || null;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
};

export const updateUserProfile = async (payload, isFormData = false) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${token}`,
        ...(isFormData
          ? { "Content-Type": "multipart/form-data" }
          : { "Content-Type": "application/json" }),
      },
    };
    const res = await axios.put(
      `${apiUrl}/user/updateprofile`,
      payload,
      config
    );
    return res.data;
  } catch (error) {
    console.error("Error updating user profile:", error);
    throw error;
  }
};

export const searchBooks = async (payload = {}) => {
  try {
    // Remove keys with empty string values
    const filteredPayload = Object.fromEntries(
      Object.entries(payload).filter(([_, v]) => v !== "")
    );
    const res = await axios.post(`${apiUrl}/books/searchbooks`, filteredPayload, {
      headers: { "Content-Type": "application/json" }
    });
    return res.data?.allBooks || [];
  } catch (error) {
    console.error("Error searching books:", error);
    return [];
  }
};

export const getBookById = async (id) => {
  try {
    const res = await axios.get(`${apiUrl}/books/getbook/${id}`);
    return res.data?.book || null;
  } catch (error) {
    console.error("Error fetching book by id:", error);
    return null;
  }
};


export const createbooking = async ({ addressId, token, type = '', bookId, quantity, comboId }) => {
  try {
    const payload = { addressId };
    if (type) payload.type = type;
    if (bookId) payload.bookId = bookId;
    if (quantity) payload.quantity = quantity;
    if (comboId) payload.comboId = comboId;
    const response = await axios.post(
      `${apiUrl}/bookings/createbooking`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error creating booking:", error);
    throw error;
  }
};
export const getSubcategoriesByCategory = async (categoryId) => {
  try {
    const res = await axios.get(
      `${apiUrl}/subcategories/getsubcategoriesbycategory`,
      { params: { categoryId } }
    );
    return res.data?.subCategories || [];
  } catch (error) {
    console.error("Error fetching subcategories:", error);
    return [];
  }
};

export const getBooksBySubcategory = async (subCategoryId) => {
  try {
    const res = await axios.get(
      `${apiUrl}/books/getbooksbysubcategory`,
      { params: { subCategoryId } } // <-- Use params, not path
    );
    return res.data?.books || [];
  } catch (error) {
    console.error("Error fetching books by subcategory:", error);
    return [];
  }
};

export const resendOtp = async (payload) => {
  try {
    const response = await axios.post(`${apiUrl}/user/resendotp`, payload);
    return response.data;
  } catch (error) {
    console.error("Error resending OTP:", error);
    throw error;
  }
};

export const getAllAuthors = async () => {
  try {
    const res = await axios.get(`${apiUrl}/authors/getauthors`);
    return res.data?.authors || res.data || [];
  } catch (error) {
    console.error("Error fetching authors:", error);
    return [];
  }
};

export const getComboOfferById = async (id) => {
  try {
    const res = await axios.get(`${apiUrl}/combooffers/getcomboofferbyid/${id}`);
    return res.data?.comboOffer || null;
  } catch (error) {
    console.error("Error fetching combo offer by id:", error);
    return null;
  }
};


